import { OrderWarehouseDataItem } from '@apis/trackOrders/TrackOrdersApi.types';
import { Account } from '@apis/users/UsersApi.types';
import { getSubAccountDescription } from '@helpers/treeHelper';

export const getAccountTagLabel = (
    value: string,
    accounts: Account[] | undefined
) => {
    if (!accounts || accounts.length === 0) return '';

    const [accId, subAccId] = value.split('-').map(Number);
    const account = accounts.find((item) => item.accountId === accId);

    if (!account) return '';

    const accNumber = account.accountNumber || '';
    if (!subAccId) return accNumber;

    const subAccLabel = getSubAccountDescription(subAccId, account.subAccounts);
    return `${accNumber}: ${subAccLabel}`;
};

export const getSslTagLabel = (
    value: string,
    data?: OrderWarehouseDataItem
) => {
    if (!data?.availableSslList?.length) return '';

    const products = value.split('_');

    for (const region of data?.availableSslList) {
        if (region.regionCode === products[0]) {
            if (products.length === 1) {
                return region.region;
            }

            for (const country of region.availableCountries) {
                if (
                    products.length === 2 &&
                    country.countryCode === products[1]
                ) {
                    return country.country;
                }

                if (
                    products.length === 3 &&
                    country.countryCode === products[1]
                ) {
                    const ssl = country.sslList.find(
                        (ssl) => ssl.code === products[2]
                    );
                    if (ssl) {
                        return ssl.code;
                    }
                }
            }
        }
    }

    return '';
};
